<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AuthOverlayGate from '@/components/layout/AuthOverlayGate.vue'
import { usesLtiAuthentication } from '@/auth/authSurfacePolicy'

const route = useRoute()
const viewOwnsAuthGate = computed(() => route.meta.authGateScope === 'view')
const ltiAuthenticated = computed(() => usesLtiAuthentication(route.meta.launchContext))
</script>

<template>
  <div class="relative h-full w-full">
    <RouterView />
    <AuthOverlayGate v-if="!viewOwnsAuthGate && !ltiAuthenticated" />
  </div>
</template>
